export default [
  {id: 1, description: 'Search By Member ID or Name', selected: true},
  {id: 2, description: 'Search By Captains & Coordinators', selected: false},
  {id: 3, description: 'Search By Reservation Number', selected: false}
];



// WEBPACK FOOTER //
// ./src/features/admin/home/searchByOptions.js